const React = require("react");
const T = React.PropTypes;

const HistoryItemGroup = React.createClass({
    props: {
        style: T.object,
        children: T.node,
        Title: T.string.isRequired
    },
    getDefaultProps(){
        return {
            style: {}
        };
    },
    render() {
        return (<section style={this.props.style}>
            <h4 style={{ paddingLeft: 20, textAlign: "left" } }>
                {this.props.Title}
            </h4>
            <div>
                {this.props.children}
            </div>
        </section>);
    }
})

module.exports = HistoryItemGroup;


// WEBPACK FOOTER //
// ./src/components/HistoryItemGroup.jsx